<template>
<div>
  <b-container fluid class=" main centered">
    <b-row id="main">
	    <b-col cols="12">
	    	<b-row class="main-text">
    			
				<b-container class="centered">
				
				<b-row>
				  <b-col md="12" class="centered">
					<!-- Искусство быть экскурсо­водом...<br>-->
					Курсы экскурсоводов
				  </b-col>
				</b-row>
				
				
				<b-row>
				  <b-col md="12">
					 <!--<div class="" style="display:inline-block;">
					  <img src="../assets/1-01.png" class="" width="40px">
					</div>-->
					   Первое занятие 2&nbsp;октября 2025&nbsp;в 19:00
					   <div style="font-size: 57%;">по адресу: Лиговский пр. д.10 (холл гостиницы «Октябрьская»)</div>
				  </b-col>
				  <!-- <div class="col-md-12 small">Осталось 16 мест</div>	  -->  
				</b-row>
				
				
				<b-row class="btn-row">
				  <b-col md="12" class="centered">
					<b-btn @click="showModal = true" variant="success">Записаться <span class="d-none d-md-inline-block">на первое занятие</span></b-btn>
					<!--<b-btn @click="showModal = true" variant="success">Записаться на первое занятие!</b-btn>-->
				  </b-col>
					<b-col md="12">
						<span style="font-size: 57%;">Количество мест ограничено. Успейте записаться!</span><br>
						<a href="tel:+78129161500" style="color:white;">+7 (812) 916-15-00</a><br>
						<span style="font-size: 57%;">Позвоните нам и мы развеем ваши сомнения!</span>
						</small>
					</b-col>
				</b-row>


				
				<!--
				<b-row>
				<b-col md="12" class="centered">
						Пройдите курс и станьте профессионалом!<br><br>
					<router-link class="btn btn-success" :to="{name: 'CoursesEntry'}">Узнать стоимость</router-link>
				</b-col>
				</b-row>
				-->
			
				</b-container>
	    	</b-row>
	    </b-col>
		</b-row>
    <transition name="fade">
      <i v-show="!wasScrolled" @click="scrollDown" class="fa fa-arrow-circle-o-down fa-2x scroll-down-btn" aria-hidden="true"></i>
    </transition>
  </b-container>
  
  <b-container class="my-4" >
				<b-row>
				<b-col md="12" class="centered">
ВСЕМ,<br>
КТО любит наш город 
       и готов рассказывать о нем бесконечно,  <br>
КТО хочет узнать больше о Санкт-Петербурге 
                              и пригородах,<br>
КТО стремится стать профессиональным экскурсоводом.
				</b-col>
				</b-row>
  </b-container>
  
  <b-container class="my-4" >
    <b-row align-h="center">
      <b-modal
        id="fastEnrollModal"
        title="Запись на курсы"
        v-model="showModal"
        :hideFooter="true"
        @shown = "yaEvent('openTrialLessonForm')"
      >
        <ext-form
          submitBtnText="Записаться"
          :submitProxy="{
              url: '/fastEnrollment.php',
              method: 'post'
          }"
          :formData="formData"
          :validator = "this.$validator"
          :scrollToError = "false"
          submitBtnClasses="btn btn-success float-right"
          successMsg="Заявка успешно отправлена"
          errorMsg="Ошибка, попробуйте позже"
          @submitSuccess="onSubmit"
          @submitFailed="yaEvent('sendTrialLessonForm', 'ошибка при отправке')"
        >
          <b-form-fieldset
            label="Фамилия Имя Отчество"
            :feedback = "errors.first('fio')"
            :class="{'is-invalid': errors.has('fio') }"
          >
            <input class="form-control" v-model="formData.fio" name="fio"/>
          </b-form-fieldset>
          <b-form-fieldset
            label="Телефон"
            :feedback = "errors.first('tel')"
            :class="{'is-invalid': errors.has('tel') }"
          >
            <input class="form-control" v-model="formData.tel" name="tel" v-validate="'required'" v-mask="'+7 (###) ###-##-##'"/>
          </b-form-fieldset>
        </ext-form>
      </b-modal>
    </b-row>
	
	<h2 class="centered" id="courses">Что будет на бесплатном занятии</h2>
	<b-row align-h="center" class="courses-icon">
		<b-col md="7">
			<div class="col-md-12 small">
				Вас ЖДЁТ:
				<ul>
				<li>Знакомство с профессией и квалификационными требованиями к экскурсоводам</li>
				<li>Информация об особенностях обучения</li>
				</ul>
				Вы СМОЖЕТЕ:
				<ul>
				<li>Оценить уровень дохода в профессии</li>
				<li>«примерить» профессию экскурсовода на себя</li>
				<li>Поучаствовать в розыгрыше с профессиональным уклоном</li>
				</ul>
				<b-btn @click="showModal = true" variant="success">Записаться на первое занятие!</b-btn>
			</div>
		</b-col>
	</b-row>
	<hr class="my-10">
	
    <h2 class="centered" id="courses">Курсы</h2>
    <b-row align-h="center" class="centered courses-icon">
      <b-col md="4">
        <router-link class="nav-link" :to="{name: 'CoursesEntry'}">
          <img src="../assets/7-02.png" alt="" width="200" class="mx-auto">
        </router-link>
        <p>
           Начальный уровень
        </p>
      </b-col>
	  
	  <!--
      <b-col md="4">
        <router-link class="nav-link" :to="{name: 'CoursesAdvanced'}">
          <img src="../assets/8-02.png" alt="" width="200" class="mx-auto">
        </router-link>
        <p>
           Продвинутый уровень
        </p>
      </b-col>
	  -->
	  
    </b-row>
    <hr class="my-10">
    <h2 class="centered">Наши преимущества</h2><br>
    <b-row class="centered icon" align-h="around">
      <b-col md="4" sm="10">
        <img src="../assets/9-01.png" alt="" width="150">
        <p>
           Трудоустройство отличников
        </p>
      </b-col>
      <b-col md="4" sm="10">
        <img src="../assets/2-01.png" alt="" width="150">
        <p>
           Курсы сертифицированы для аккредитации при Правительстве Санкт-Петербурга
        </p>
      </b-col>
      <b-col md="4" sm="10">
        <img src="../assets/4-01.png" alt="" width="150">
        <p>
          Расписание занятий в вечернее время
        </p>
      </b-col>
    </b-row>
    <b-row class="centered icon" align-h="around">
      <b-col md="4" sm="10">
        <img src="../assets/5-01.png" alt="" width="150">
        <p>
          В курсе 9 экскурсий
        </p>
      </b-col>
      <b-col md="4" sm="10">
        <img src="../assets/6-01.png" alt="" width="150">
        <p>
           Практические занятия на базе туроператора по приему туристов в Санкт-Петербурге
        </p>
      </b-col>
      <b-col md="4" sm="10">
        <img src="../assets/7-01.png" alt="" width="150">
        <p>
          Практика проведения экскурсий на живой группе
        </p>
      </b-col>
    </b-row>
    <b-row class="centered icon" align-h="around">
      <b-col md="4" sm="10">
        <router-link class="nav-link" :to="{name: 'CoursesAdvanced'}">
          <img src="../assets/8-01.png" alt="" width="150">
        </router-link>
        <p>
          Повышение квалификации экскурсоводов
        </p>
      </b-col>
      <b-col md="4" sm="10">
        <img src="../assets/3-01.png" alt="" width="150">
        <p>
          Помесячная оплата
        </p>
      </b-col>
    </b-row>
	
				<b-row class="btn-row">
				  <b-col md="12" class="centered">
					<b-btn @click="showModal = true" variant="success">Записаться</b-btn>
				  </b-col>
				</b-row>
	<!--			
    <br>
		<hr class="my-10">
    <h2 class="centered">Обращение директора</h2><br>
    <b-row>
      <b-col md="4" class="mr-auto centered" style="white-space: nowrap;">
        <span class="director-photo-helper"></span>
        <img src="../assets/director.jpg" width="350" class="director-photo img-thumbnail rounded-circle" alt="">
      </b-col>
			<b-col md="7">
        <div class="speech-bubble">
          <p class="text-justify font-italic">
            Дорогие друзья! Приглашаем  на Курсы экскурсоводов всех, кто влюблен в
            Санкт-Петербург и готов  изучать его бесконечно, кто любит творить и
            учиться, познавать новое и общаться с людьми. На протяжении многих лет
            в нашем городе сложилась классическая петербургская школа экскурсоведения.
            Лучшие специалисты будут пере&shy;да&shy;вать Вам накопленный опыт, делиться
            своими знаниями и секретами профессии.
            Желаю Вам успехов на этом сложном, но необычайно интересном поприще.
          </p>
          <p class="text-right">
            Директор ГБНОУ «Дворец учащейся молодежи Санкт&nbsp;-&nbsp;Петербурга», <br>
            кандидат педагогических наук <br>
            Еселева Л.А.
          </p>
        </div>
			</b-col>
		</b-row>
	-->
	
    <hr class="my-10">
    <b-row>
			<b-col md="12">
				<h2 class="centered">Отзывы</h2><br>
			</b-col>
		</b-row>
    <b-row>
      <div class="col-md-12 col-12">
        <carousel
          :perPage="slidePerPage"
          :autoplay="sliderAutoplay"
          :navigationEnabled="true"
          navigationNextLabel='<i class="fa fa-chevron-right fa-2x" aria-hidden="true"></i>'
          navigationPrevLabel='<i class="fa fa-chevron-left fa-2x" aria-hidden="true"></i>'
          @pageChange = "collapseAll"
          ref="slider"
          :minSwipeDistance="80"
        >
          <slide v-for="(item, index) in feedbacks" :key="index">
            <b-row class="feedback">
              <b-col md="3">
                <img :src="item.img" width="220" class=" img-thumbnail rounded-circle" alt="">
              </b-col>
              <b-col md="9" >
                <p class="text-justify font-italic" >
                  <span v-html="item.text"></span>
                  <template v-if="item.collapsed">
                    <b-collapse  :id="'collapsed' + index">
                      <span v-html="item.collapsed"></span>
                    </b-collapse>
                    <b-btn v-b-toggle="'collapsed' + index" variant="link">
                      Читать полностью
                    </b-btn>
                  </template>
                </p>
                <p class="text-right">
                  {{item.author}}
                </p>
              </b-col>
            </b-row>
          </slide>
        </carousel>
      </div>
    </b-row>
	
	<!--
    <hr class="my-10" id="contact">
    <b-row>
			<b-col class="centered">
				<h2 class="">Контакты</h2>
        <br>
        <contacts :height="350"></contacts>
			</b-col>
		</b-row>
	-->
	
	</b-container>
</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import Contacts from '@/components/Contacts'
import Feedbacks from '@/data/Feedback'
import ExtForm from '@/components/ExtForm'
import Scroll from 'smooth-scroll'

export default {
  name: 'home',
  data () {
    return {
      showModal: false,
      feedbacks: Feedbacks,
      sliderAutoplay: false,
      slidePerPage: 1,
      wasScrolled: false,
      formData: {
        fio: '',
        tel: ''
      }
    }
  },
  mounted () {
    if (window.screen.height >= 400) {
      window.addEventListener('scroll', () => {
        this.wasScrolled = window.pageYOffset >= 100
      })
    } else {
      this.wasScrolled = true
    }
  },
  methods: {
    scrollDown () {
      const scroll = new Scroll()
      const anchor = document.querySelector('#courses')
      scroll.animateScroll(anchor, null, {
        offset: 100
      })
    },
    onSubmit () {
      this.yaEvent('sendTrialLessonForm', 'успешная отправка')
      this.showModal = false
      // this.$root.$emit('hide::modal', 'fastEnrollModal')
    },
    yaEvent (name, msg) {
      if (this.$getYaCounter) {
        this.$getYaCounter().reachGoal(name, msg)
      }
    },
    collapseAll (e) {
      const uncollapsed = this.$refs.slider.$el.querySelector('.show')
      if (uncollapsed) {
        this.$root.$emit('collapse::toggle', uncollapsed.id)
      }
    }
  },
  components: {
    Carousel,
    Slide,
    Contacts,
    ExtForm
  }
}
</script>

<style >
  .VueCarousel-navigation-next, .VueCarousel-navigation-prev {
      margin: 0 !important;
      padding: 0 !important;
  }
  .VueCarousel-navigation-prev {
      margin: 0;
  }
  .VueCarousel-slide {
    text-align: center;
  }
  .icon {
    font-size: 20px;
  }
  .courses-icon {
    font-size: 20px;
  }

  .courses-icon img {
    display: block;
    -webkit-transform: scale(1,1);
    -webkit-transition-timing-function: ease-out;
    -webkit-transition-duration: 550ms;
    -moz-transform: scale(1,1);
    -moz-transition-timing-function: ease-out;
    -moz-transition-duration: 550ms;
  }
  .courses-icon img:hover {
    -webkit-transform: scale(1.1,1.1);
    -webkit-transition-timing-function: ease-out;
    -webkit-transition-duration: 550ms;
    -moz-transform: scale(1.1,1.1);
    -moz-transition-timing-function: ease-out;
    -moz-transition-duration: 550ms;
  }
  .main-text {
    font-size: 30px;
    padding: 4vh 0;
    position: relative;
    top: 35vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .main button {
		font-size: 25px;
	}
  .main {
		background-image: url(../assets/main3.jpeg);
		background-position: center;
		background-size: cover;
		height: 100vh;
		color: white;
	}
  .scroll-down-btn {
    cursor: pointer;
  }
  .fa.fa-arrow-circle-o-down:hover {
    animation: beat .25s infinite alternate;
  	transform-origin: center;
  }
  .fa.fa-arrow-circle-o-down {
    bottom: 20px;
    margin-left: -15px;
    position: absolute;
  	color: white;
  }
  /* Heart beat animation */
  @keyframes beat{
  	to { transform: scale(1.4); }
  }
  .feedback {
    padding: 10px 0px;
    margin: 0 1vw!important;
    border: 2px solid #e5e5e5;
  }

  .feedback button {
    padding: 0;
    margin: 0;
  }

  .director-photo-helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  .director-photo {
    vertical-align: middle;
  }
  .speech-bubble p {
    color: black;
  }
  .speech-bubble {
    margin-top: 26px;
    position: relative;
    color: white;
    text-align: center;
    font-family: sans-serif;
    border: 1px solid #e5e5e5;
    padding: 20px;
    box-shadow: 5px 5px 10px rgba(0,0,0,0.1);
  }
  .speech-bubble:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: 20px solid;
    border-right-color: #e5e5e5;
    top: 50%;
    right: 100%;
    margin-top: -15px;
  }

  .block:hover {
    text-decoration: none;
    color: black;
    box-shadow: 0.1em 0.1em 8px rgba(122,122,122,0.5);
    cursor: pointer;
  }
  #about {
		padding-top: 70px;
	}
  .main .btn-row {
    margin-top: 20px;
  }

  @media (max-width: 575px) and (min-height: 568px){
    .feedback .text-justify {
      min-height: 480px;
    }
  }

  @media (min-width: 576px) and (max-width: 767px) {
    .feedback {
      min-height: 540px;
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .feedback {
      min-height: 320px;
    }
  }

  @media (max-width: 767px){
    .speech-bubble:after {
      display: none;
    }
  }

  @media screen and (max-width: 500px), (max-height: 500px) {
    .main-text {
      font-size: 1.1em;
    }
    .main .btn-row {
      margin-top: 20px;
    }
  }
  @media (max-width: 600px) {
    .VueCarousel-navigation-next, .VueCarousel-navigation-prev {
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?dcc761d2